<template>
  <v-card
    class="rounded-lg"
    width="100%"
    elevation="0"
    v-bind="$attrs"
    :height="$attrs.height || '80vh'"
  >
    <v-skeleton-loader
      v-if="isLoading || !data"
      type="article"
    ></v-skeleton-loader>
    <v-card-title v-else>
      <h4 class="grey--text text--darken-2">
        {{ profile.name || 'N&frasl;A' }}
      </h4>
    </v-card-title>

    <v-skeleton-loader
      v-if="isLoading || !data"
      type="sentences, sentences, sentences, sentences, sentences, sentences, sentences, sentences, sentences, sentences"
      class="pa-4"
    ></v-skeleton-loader>
    <v-card-text
      v-else
      class="overflow-y"
      :style="{height : contentHeight}"
    >
      <div>
        <!-- keymaps -->
        <v-row
          dense
        >
          <!-- section1 -->
          <v-col
            v-for="key in keyMap.section1"
            :key="key.value"
            :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" 
            cols='12'
          >
            <span class="d-block">{{ key.name }}</span>
            <span
              :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`"
            >
              {{ profile[key.value] || 'N&frasl;A' }}
            </span>
          </v-col>

          <!-- divider -->
          <v-col
            cols="12"
            class="my-3"
          >
            <v-divider class="secondary darken-2"></v-divider>
          </v-col>

          <!-- section2 -->
          <v-col
            v-for="key in keyMap.section2"
            :key="key.value"
            :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" 
            cols='12'
          >
            <span class="d-block">{{ key.name }}</span>
            <span
              :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`"
            >
              {{ profile[key.value] || 'N&frasl;A' }}
            </span>
          </v-col>

          <!-- divider -->
          <v-col
            cols="12"
            class="my-3"
          >
            <v-divider class="secondary darken-2"></v-divider>
          </v-col>

          <!-- section3 -->
          <v-col
            v-for="key in keyMap.section3"
            :key="key.value"
            :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" 
            cols='12'
          >
            <span class="d-block">{{ key.name }}</span>
            <span
              :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`"
            >
              {{ profile[key.value] || 'N&frasl;A' }}
            </span>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import nameMixin from "@/mixins/name";

  export default {
    name: 'CasePatientProfile',

    mixins: [nameMixin],

    props: {
      contentHeight: {
        type: String,
        default: '85%'
      }
    },

    computed: {
      caseId() {
        return this.$route.params.id
      },
      data() {
        return this.$store.getters['ror/data']
      },
      profile() {
        console.log('data', this.data)
        var has_user = false
        var user = {}
        var has_patient = false
        var patient = {}

        if (this.data !== null && this.data !== undefined) {
          has_user = Object.prototype.hasOwnProperty.call(this.data, 'patient')
          has_patient = Object.prototype.hasOwnProperty.call(this.data.patient, 'patient')

          if (has_user) {
            user = this.data.patient ? this.data.patient : {}

            if (has_patient) {
              patient = this.data.patient.patient ? this.data.patient.patient : {}
            }
          }
        }

        console.log('[has-user]', has_user, user)
        console.log('[has-patient]', has_patient, patient)

        return {
          name: this.getPatientName(user),
          // section 1
          preferred_language: patient.preferred_language,
          health_concern: this.data.health_concern,
          case_number: this.data.case_number,
          user_type: user.user_type,
          insurance_provider: user.insurance_provider,
          insurance_number: user.insurance_number,
          contact_number: patient.mobile_number,
          company_name: user.company_name,
          is_vip: patient.is_vip ? 'Yes' : 'No',
          has_warning: patient.has_warning ? patient.has_warning : 'No',
          warning_reason: patient.warning_reason,
          // section 2
          gender: patient.gender,
          marital_status: patient.marital_status,
          age: patient.age,
          birthdate: patient.birthdate,
          height: patient.height,
          weight: patient.weight,
          bmi: patient.bmi,
          date_measured: patient.date_measured,
          // section 3
          case: `Case #${this.data.id}`,
          consultations: `${this.data.consultations.length} (for this case)`
        }
      }
    },

    data:()=>({
      isLoading: true,
      keyMap: {
        section1: [
          {name: 'Language', value: 'preferred_language', section: 'patient'},
          {name: 'Case Title', value: 'health_concern', section: 'case'},
          {name: 'Case No.', value: 'case_number', section: 'case'},
          {name: 'Caller Role', value: 'user_type', section: 'user'},
          {name: 'Provider name', value: 'insurance_provider', section: 'user'},
          {name: 'Insurance No.', value: 'insurance_number', section: 'user'},
          {name: 'Contact No.', value: 'contact_number', section: 'patient'},
          {name: 'Company name', value: 'company_name', section: 'user'},
          {name: 'VIP', value: 'is_vip', section: 'patient'},
          {name: 'Warning', value: 'has_warning', section: 'patient'},
          {name: 'Warning reason', value: 'warning_reason', section: 'patient'},
        ],
        section2: [
          {name: 'Gender', value: 'gender', section: 'patient'},
          {name: 'Marital status', value: 'marital_status', section: 'patient'},
          {name: 'Age', value: 'age', section: 'patient'},
          {name: 'Birthdate', value: 'birthdate', section: 'patient'},
          {name: 'Height', value: 'height', section: 'patient'},
          {name: 'Weight', value: 'weight', section: 'patient'},
          {name: 'BMI', value: 'bmi', section: 'patient'},
          {name: 'Date measured', value: 'date_measured', section: 'patient'},
        ],
        section3: [
          {name: 'Case', value: 'case', section: ''},
          {name: 'Consult', value: 'consultations', section: ''},
        ]
      }
    }),

    async mounted() {
      await this.$store.dispatch('ror/getCase', this.caseId)
      this.isLoading = false
      // console.log('[case-data]', this.data)
    },

    methods: {
      //
    }
  }
</script>

<style lang="scss" scoped>
  span {
    font-size: .9em;
  }
</style>